var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 50,
    height: 50,
    rx: 25,
    stroke: "#E7F7EF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3077 26.7377H22.923C22.6077 26.7377 22.3461 26.4742 22.3461 26.1563C22.3461 25.8385 22.6077 25.5749 22.923 25.5749H28.3077C28.623 25.5749 28.8846 25.8385 28.8846 26.1563C28.8846 26.4742 28.623 26.7377 28.3077 26.7377Z",
    fill: "#27A376"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2923 29.8385H22.923C22.6077 29.8385 22.3461 29.5749 22.3461 29.2571C22.3461 28.9393 22.6077 28.6757 22.923 28.6757H26.2923C26.6077 28.6757 26.8692 28.9393 26.8692 29.2571C26.8692 29.5749 26.6077 29.8385 26.2923 29.8385Z",
    fill: "#27A376"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5384 21.9315H24.4615C23.723 21.9315 22.3461 21.9315 22.3461 19.7998C22.3461 17.668 23.723 17.668 24.4615 17.668H27.5384C28.2769 17.668 29.6538 17.668 29.6538 19.7998C29.6538 20.5439 29.6538 21.9315 27.5384 21.9315ZM24.4615 18.8308C23.7 18.8308 23.5 18.8308 23.5 19.7998C23.5 20.7687 23.7 20.7687 24.4615 20.7687H27.5384C28.5 20.7687 28.5 20.5672 28.5 19.7998C28.5 18.8308 28.3 18.8308 27.5384 18.8308H24.4615Z",
    fill: "#27A376"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3077 34.3346H23.6923C19.3692 34.3346 18.5 32.3346 18.5 29.1021V24.4509C18.5 20.916 19.7692 19.4044 22.8923 19.2416C23.2 19.2261 23.4846 19.4664 23.5 19.792C23.5154 20.1176 23.2692 20.3811 22.9538 20.3966C20.7692 20.5207 19.6538 21.1796 19.6538 24.4509V29.1021C19.6538 31.9703 20.2154 33.1718 23.6923 33.1718H28.3077C31.7846 33.1718 32.3462 31.9703 32.3462 29.1021V24.4509C32.3462 21.1796 31.2308 20.5207 29.0462 20.3966C28.7308 20.3811 28.4846 20.1021 28.5 19.7842C28.5154 19.4664 28.7923 19.2183 29.1077 19.2339C32.2308 19.4044 33.5 20.916 33.5 24.4432V29.0943C33.5 32.3346 32.6308 34.3346 28.3077 34.3346Z",
    fill: "#27A376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reportsIcon.10cc7dfa861fcec1c943cdb288ef25b1.svg";
export { ForwardRef as ReactComponent };